import React, {ReactNode} from "react";
import DataRow from "view/components/DataRow";
import clsx from "clsx";
import {SummaryRow} from "view/apps/Exhibitor/pages/Cart/components/Payment/components/Card/OrdersList/OrderSummary/utils/getOrderSummaryRows";
import useStyles from "./styles";

type OrderSummaryRowProps = {
  rowData: SummaryRow;
  actionPanel?: ReactNode;
  isLast?: boolean;
  isHighlight?: boolean;
};

const OrderSummaryRow = ({
  rowData = {} as SummaryRow,
  actionPanel,
  isLast,
  isHighlight,
}: OrderSummaryRowProps) => {
  const classes = useStyles();

  const {label, value} = rowData;
  return (
    <DataRow
      classes={{
        label: clsx(classes.summaryLabel, {
          [classes.contrastText]: !!isHighlight,
        }),
        value: clsx(classes.value, {[classes.bold]: !!isHighlight}),
        row: classes.row,
        actionPanel: classes.actionPanel,
      }}
      label={label}
      value={value}
      last={isLast}
      actionPanel={actionPanel}
    />
  );
};

export default OrderSummaryRow;
